import * as React from 'react';

import { ShowAloneSide } from '../../../../../containers/Editor/constants';
import { EmptyWrapper, Wrapper } from './styles';

interface ImageProps {
	imageSrc: string;
	side: ShowAloneSide;
}

const Image = ({ imageSrc, side }: ImageProps) => {
	const image = React.useRef<HTMLImageElement>(null);

	React.useEffect(() => {
		if (image.current) {
			// is needed to update image in lazysizes library
			image.current.classList.add('lazyload');
		}
	}, [imageSrc]);

	return (
		imageSrc ?
			(
				<Wrapper side={side}>
					<img
						ref={image}
						className="lazyload"
						data-src={imageSrc}
						alt=""
					/>
				</Wrapper>
			)
			:
			(
				<EmptyWrapper>
					<div />
				</EmptyWrapper>
			)
	);
};

export default Image;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Thumbnails/Item/Image/index.tsx